import { useGetOrganizationByIdQuery } from '@/apis/hooks/organizations';
import { useParams } from 'react-router-dom';

const useOrg = () => {
  const { orgId } = useParams<{ orgId: string }>();

  const { data: org } = useGetOrganizationByIdQuery(orgId || '', Boolean(orgId));

  return org || null;
};

export default useOrg;
